import { createReducer, on } from '@ngrx/store';
import { DefaultPageSize } from '../../../shared/constants/pagination.constants';
import { SavingStatus } from '../../../shared/models/list.page.model';
import * as alertActions from './alert.actions';
import { AlertsState } from './alert.models';

export const alertInitialState: AlertsState = {
    alertConfigurations: [],
    alertConfigurationsPage: null,
    alertConfigurationsPagination: {
        pageIndex: 0,
        pageSize: DefaultPageSize,
    },
    alertConfigurationsSaveInProgress: SavingStatus.NotStarted,
    loading: false,
    error: null,
};

export const alertsReducer = createReducer(
    alertInitialState,
    on(alertActions.loadAlertConfigurationList, (state) => ({
        ...state,
        loading: true,
    })),
    on(alertActions.loadAlertConfigurationListSuccess, (state, { response }) => ({
        ...state,
        loading: false,
        error: null,
        alertConfigurations: response.result ?? [],
        alertConfigurationsPage: {
            ...state.alertConfigurationsPage,
            totalCount: response.total ?? 0,
            pageIndex: response.pageIndex ?? 0,
            pageSize: response.pageSize ?? 0,
        },
    })),
    on(alertActions.loadAlertConfigurationListFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'Error',
    })),
    on(alertActions.changeAlertConfigurationPagination, (state, { pageIndex, pageSize }) => ({
        ...state,
        alertConfigurationsPagination: { pageIndex, pageSize },
    })),
    on(alertActions.insertAlertConfiguration, (state) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.InProgress,
    })),
    on(alertActions.insertAlertConfigurationSuccess, (state) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.Successful,
    })),
    on(alertActions.insertAlertConfigurationFailure, (state, { error }) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.Failure,
        error: error.errorMessage ?? 'Error',
    })),
    on(alertActions.updateAlertConfiguration, (state) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.InProgress,
    })),
    on(alertActions.updateAlertConfigurationSuccess, (state) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.Successful,
    })),
    on(alertActions.updateAlertConfigurationFailure, (state, { error }) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.Failure,
        error: error.errorMessage ?? 'Error',
    })),
    on(alertActions.deleteAlertConfigurationSuccess, (state) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.Successful,
    })),
    on(alertActions.deleteAlertConfigurationFailure, (state, { error }) => ({
        ...state,
        alertConfigurationsSaveInProgress: SavingStatus.Failure,
        error: error.errorMessage ?? 'Error',
    }))
);
